export const MODULE_ID = 'b2b_online_acq_dedicated';
export const AUTHORIZATION_HEADER = 'Authorization';
export const PNQ_AUTHORIZATION_HEADER = 'PnqAuthorization';
export const SUMMARY_AUTHORIZATION_HEADER = 'summary_authorization';
export const SUMMARY_AUTH_TOKEN = 'SUMMARY_AUTH_TOKEN';
export const AUTHORIZED_SIGNATORY = 'authorizedSignatory';
export const LEAD = 'lead';
export const ORDER = 'order';
export const OV_TOKEN = 'ov-token';

export const COMMON_API_HEADERS = {
  // 'iv-user': 'test@gmail.com',
  'Content-Type': 'application/json'
};

export const PNQ_API_HEADERS = {
  //  "iv-user": "pramod5.kumar@airtel.com",
  'Content-Type': 'application/json'
};

export const LEAD_API_HEADERS_DEV = {
  'iv-user': 'test@gmail.com',
  'Content-Type': 'application/json'
};
